import { useState } from 'react'
import { useSelector } from 'react-redux'
import * as S from './styles'
import IconAlertSuccess from '../../assets/icons/icon-alert-success.svg'
import { HiX } from 'react-icons/hi'

const ToastCotacao = ({ message }) => {
  const store = useSelector((store) => store)
  // const [display, setDisplay] = useState(true)

  // if (!display) return <div/>

  return (
    <S.Container>
      <img
        src={IconAlertSuccess}
        style={{ width: 30, marginRight: 12, height: 30 }}
        alt=""
      />
      <strong>{message}</strong>
      {/* <button onClick={() => setDisplay(false)} type="button">
        <HiX size={24} />
      </button> */}
    </S.Container>
  )
}

export default ToastCotacao
